var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"update-in-table"},[_c('v-row',{staticClass:"mx-0",attrs:{"align":"center","justify":"center"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }